export function target() {
  return ['PageSettings'].includes(this.module);
}

export function migrate() {
  if (this.data.pageHeadingFont === 'Calibri') {
    this.data.pageHeadingFont = 'Open Sans';
  }
  if (this.data.pageBodyFont === 'Calibri') {
    this.data.pageHeadingFont = 'Open Sans';
  }
}
